import FAQInBlockPreview from "./FAQInBlockPreview";

export default FAQInBlockPreview;